"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

exports.textStyle = hs_web_style_guide_1.css({
  paddingRight: 8
});
exports.dropdownItemStyle = hs_web_style_guide_1.css({
  ':hover': {
    backgroundColor: colors_1.merino
  }
});
exports.leftStyle = hs_web_style_guide_1.css({
  left: 0
});
exports.rightStyle = hs_web_style_guide_1.css({
  right: 0
});
exports.middleStyle = hs_web_style_guide_1.css({
  left: '50%'
});

exports.positionStyle = function (position) {
  switch (position) {
    case 'left':
      return exports.leftStyle;

    case 'right':
      return exports.rightStyle;

    default:
      return exports.middleStyle;
  }
};

exports.dropdownDisplayStyle = hs_web_style_guide_1.css({
  display: 'block',
  padding: 20,
  textDecoration: 'none',
  color: colors_1.comet,
  fontSize: 16
});
exports.dropdownLinkStyle = exports.dropdownDisplayStyle;

exports.dropdownItemsStyle = function () {
  return hs_web_style_guide_1.css({
    marginTop: 8,
    borderRadius: 4,
    border: "1px solid " + colors_1.carrarra,
    backgroundColor: colors_1.white
  });
};

exports.dropdownContentStyle = function (options) {
  return hs_web_style_guide_1.css({
    display: 'none',
    position: 'absolute',
    background: 'transparent',
    minWidth: options.minWidth,
    zIndex: 1
  });
};

exports.dropdownStyle = function (_a) {
  var ctaHoverBackgroundColor = _a.ctaHoverBackgroundColor,
      isIconButton = _a.isIconButton;
  return hs_web_style_guide_1.css({
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
    '.dropdown:hover .dropdownContent': {
      display: 'block'
    },
    '.dropdown:hover .dropdownCta': {
      backgroundColor: ctaHoverBackgroundColor,
      borderRadius: isIconButton ? '50%' : '4px'
    }
  });
};

exports.dropdownCtaStyle = function (options) {
  return hs_web_style_guide_1.css({
    backgroundColor: 'transparent',
    color: options.ctaColor,
    letterSpacing: options.letterSpacing ? 2.5 : 0,
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    textTransform: options.uppercase ? 'uppercase' : null,
    padding: options.isIconButton ? '12px' : '12px 24px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
      backgroundColor: options.ctaHoverBackgroundColor,
      borderRadius: options.isIconButton ? '50%' : '4px'
    }
  });
};